import { render, staticRenderFns } from "./KanjiTermsExamples.vue?vue&type=template&id=6f4026ea&scoped=true"
import script from "./KanjiTermsExamples.vue?vue&type=script&lang=js"
export * from "./KanjiTermsExamples.vue?vue&type=script&lang=js"
import style0 from "./KanjiTermsExamples.vue?vue&type=style&index=0&id=6f4026ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4026ea",
  null
  
)

export default component.exports